module.exports = __webpack_public_path__ + "856203025ade3c5bedee390faeb1e06b.png";